module.exports = __webpack_public_path__ + "static/media/mtu.65c0f2c3.png";